module.exports = __webpack_public_path__ + "NeueFrutigerWorld-BlackIt.0d6c7485e4cc9ad0be6e.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-BlackIt.ttf
// module id = ../../../../../src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-BlackIt.ttf
// module chunks = styles